export default "__VITE_ASSET__kEonzEz2__"